import { FinanceCondition, PublicOffer } from 'types';

export interface OrderPageState {
  order?: PublicOffer;
  isFetchingResult: boolean;
  isUpdatingOrder: boolean;
  updateSuccess: boolean;
  errorMessages?: Array<string>;
  teslaTrimCodes: string[];
  isFetchingTeslaTrimCodes: boolean;
  financeConditions: FinanceCondition[];
  isFetchingFinanceConditions: boolean;
}

export const initialState: OrderPageState = {
  order: undefined,
  isFetchingResult: false,
  isUpdatingOrder: false,
  updateSuccess: false,
  errorMessages: [],
  teslaTrimCodes: [],
  isFetchingTeslaTrimCodes: false,
  financeConditions: [],
  isFetchingFinanceConditions: false,
};
